import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./alert-md.svg?react";

export const AlertMdIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
